"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Banner = ({ type }) => (react_1.default.createElement("div", { className: styles_scss_1.default.bannerContainer },
    react_1.default.createElement("img", { className: styles_scss_1.default.bannerImage, src: type === 'success' ? constants_1.Images.congrats : constants_1.Images.undrawCancel, alt: "congrats" }),
    react_1.default.createElement("h2", null, type === 'success' ? constants_1.default.paywall.payment.congratulations : constants_1.default.paywall.payment.oops),
    react_1.default.createElement("p", null, type === 'success'
        ? constants_1.default.paywall.payment.successfullyActivatedProgram
        : constants_1.default.paywall.payment.declinedPayment),
    react_1.default.createElement(components_1.Link, { to: constants_1.Routes.Program },
        react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.bannerButton, title: type === 'success' ? constants_1.default.paywall.payment.letsStart : constants_1.default.paywall.payment.retry, ariaLabel: type === 'success' ? constants_1.default.paywall.payment.letsStart : constants_1.default.paywall.payment.retry }))));
exports.Banner = Banner;
const PaywallPaymentScreen = ({ user, decodeHash, location, hydrateUser, }) => {
    const [banner, setBanner] = react_1.useState(null);
    if (lodash_1.isEmpty(user)) {
        return react_1.default.createElement(components_1.ScreenLoader, null);
    }
    const { clientSecret, price } = decodeHash(carabiners_1.createSearchObject(location.search).h);
    if (!clientSecret || !price) {
        return react_1.default.createElement(react_router_1.Redirect, { to: constants_1.Routes.PaywallSessions });
    }
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.paywall.payment.helmetTitle }),
        react_1.default.createElement("div", { className: styles_scss_1.default.contentContainer },
            react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.contentPaper }, banner ? (react_1.default.createElement(exports.Banner, { type: banner })) : (react_1.default.createElement("div", { className: styles_scss_1.default.paywallPaymentContainer },
                react_1.default.createElement(components_1.Link, { to: constants_1.Routes.PaywallSessions },
                    react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.paywall.payment.back, ariaLabel: constants_1.default.paywall.payment.back, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
                react_1.default.createElement("h2", { className: styles_scss_1.default.paymentDetailsTitle }, constants_1.default.paywall.payment.paymentDetails),
                react_1.default.createElement(forms_1.StripePaymentForm, { clientSecret: clientSecret, price: price, email: user.email, onSuccess: () => {
                        hydrateUser();
                        setBanner('success');
                    }, onError: () => setBanner('error') })))))));
};
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
});
const mapDispatchToProps = (dispatch) => ({
    decodeHash: (hash) => selectors_1.default.payment.decodeHash(hash),
    hydrateUser: () => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.hydrateUserPayload())),
});
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PaywallPaymentScreen));
